import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import PopupWrapper from "../components/PopupWrapper";
import AccountBackButton from "../components/AccountBackButton";
import DiscList from "../components/DiscList";
import Spacer from "../components/Spacer";
import AccountSubheader from "../components/AccountSubheader";

class AccountTariffInfo extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>

        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            isHistoryBack
            backLabel={"Back"}
            title="Tariff Info"
            {...this.props}
          />

            <h3>Charges and rebates</h3>

            <p><strong>Standing charge</strong>: Charged per day by the supplier for offering the service. This price is fixed independently of the consumption.</p>
            <p><strong>Import rate</strong>: The amount the supplier charges per unit of energy bought. Typically this unit is one kWh (kilowatt-hour).</p>
            <p><strong>Export rate</strong>: The amount the supplier pays back per unit of energy when the energy generated in the home is higher than the energy consumed. This excess energy is sold to the grid and the user is compensated for it. Typically the unit of energy is one kWh (kilowatt-hour).</p>
            <p><strong>Generation rate</strong>: The amount paid to the user per unit of generated energy, even if the user consumed it. Typically the unit of energy is one kWh (kilowatt-hour). This rate is quite rare, and only houses that installed solar panels during a certain period benefit from it. New installations no longer qualify for this rate.</p>
            <h3>Types of tariffs:</h3>
            <p>Import, export and generation rates can be one of 4 types, while the standing charge only has a fixed type available. These types are:</p>
            <ul>
                <li>
                    <strong>Fixed</strong>: The same unit price for all days of the week and all times of day. To create a fixed tariff, select "Every day" during creation, and add only one rate that starts at "00:00".
                </li>
                <li>
                    <strong>Day</strong>: The same unit price at all times of day, but different rates for weekdays and weekends. To use this type of tariff, set both the "Weekdays only" and "Weekends only" rates. When adding the rates per day, add one that starts at "00:00".
                </li>
                <li>
                    <strong>TOU (Time Of Usage)</strong>: Different unit prices depending on the time of day, but the same for all days of the week. To select this type of tariff, select "Every day" during creation, and add as many rates as needed by clicking on "Add new rate" (up to 48 per day). Each rate needs a name, a price and a time when that rate starts. The end does not need to be specified because it will end when the next rate starts.
                </li>
                <li>
                    <strong>Day-TOU</strong>: The most complex tariff: in practice it means there is one TOU tariff for weekends and another TOU tariff for weekdays. To use it, set both "Weekdays only" and "Weekends only" with more than one rate per day in each.
                </li>
            </ul>
        </main>
      </div>
    );
  }
}

export default AccountTariffInfo;
